import { hasValueInErrorMessage } from "../../../Utility/Utilitys";
import {
  CmpTypographyField,
  CmpDatePickerField,
  CmpSelectField,
  CmpSelectArrField,
  CmpInputField,
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { DataGrid } from "@mui/x-data-grid";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Grid from "@mui/material/Grid";
import {
  CmpDatePickerField001V1,
  CmpSelectArrFieldV1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCHead({
  xOsAmount,
  sArr,
  //grid saleshistory
  sToggleGrid,
  sGridSalesHistoryRowData,
  GridDataSalesHistoryColumns,
  //grid saleshistory end
  vRdxWmsHead,
  xPaymodeEnable,
  sDocLoadingGrnType,
  sOutboundType,
  sPaymode,
  sUnloading,
  sCurrency,
  sTax,

  fonSelectedGrnType,
  fGrnDate,
  fInvNo,
  fInvDate,
  fOutboundType,
  fPaymode,
  fSelectedUnloading,
  fSelectedCurrency,
  fTax,
  fOffer,
  fTaxable,
  fLocation,
  xKey,
  xFocusInput,
  vRdxuserLoc,
  xErrorMsg,
  xDisableBasedOnGridDataLength,
  inputFocus,
  //customer
  xfGC_Toggle_Head_Customer_Name,
  xGC_Toggle_Head_Customer_Toggle = false,
  xGC_Toggle_Head_Customer_onKeyUp,
  xGC_Toggle_Head_Customer_SearchDropdownObj,
  xGC_Toggle_Head_Customer_Dropdown_onChange,
  xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load,
  xGC_Toggle_Head_Customer_GridColumns,
  xGC_Toggle_Head_Customer_GridData,
  xfGC_Toggle_Head_Customer_OnRowClick,
  xfGC_Toggle_Head_Customer_OnCellKeyDown,
  xGC_Toggle_Head_Customer_DropDown_Arr,
  //customer end
}) {
  return (
    <form id="WmsOutboundGRVHead">
      <Grid
        container
        rowSpacing={0.9}
        columnSpacing={0.9}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        marginTop={{xs:1,sm:0,md:0,lg:0}}
      >
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={12} sm={6} md={4}>
              <CmpSelectFieldV1
                xSize="small"
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxWmsHead.A_VocTyp}
                xOnChange={fonSelectedGrnType}
                xName={"A_VocTyp"}
                xData={sDocLoadingGrnType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocTyp}
                xDisable={
                  xDisableBasedOnGridDataLength || vRdxWmsHead.A_VocNo != 0
                }
                // xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <CmpTextFieldV1
                xLabelText="Doc.No"
                xSize="small"
                xValue={vRdxWmsHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocNo}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <CmpDatePickerField001V1
                xLabelText="Doc.Date"
                xtabIndex={"2"}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxWmsHead.A_PostDt}
                xOnChange={fGrnDate}
                xName={"A_PostDt"}
                xError={xErrorMsg.A_PostDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_PostDt}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={4}>
              <CmpTextFieldV1
                xLabelText="Ref.No"
                xSize="small"
                xValue={vRdxWmsHead.A_RefNo}
                xType={"text"} // text/number/password
                xName={"A_RefNo"}
                xReadOnly={false}
                xOnChange={fInvNo}
                xError={xErrorMsg.A_RefNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_RefNo}
                xref={inputFocus}
                // xOnKeyUp={xKey}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4}>
              <CmpDatePickerField001V1
                xLabelText="Ref.Date"
                xtabIndex={"4"}
                xOnChange={fInvDate}
                xName={"A_RefDt"}
                xError={xErrorMsg.A_RefDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_RefDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={4}>
              <CmpSelectFieldV1
                xSize="small"
                xtabIndex={"5"}
                xLabelText="Paymode"
                xValue={vRdxWmsHead.A_PayMode}
                xOnChange={fPaymode}
                xName={"A_PayMode"}
                xData={sPaymode}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_PayMode === "" ? false : true}
                xErrorMessage={xErrorMsg.A_PayMode}
                // xDisable={xPaymodeEnable}
                xDisable={false} //client
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3.5}>
              <CmpSelectFieldV1
                xSize="small"
                xtabIndex={"6"}
                xLabelText="Unloading"
                xValue={vRdxWmsHead.UnloadingBay}
                xOnChange={fSelectedUnloading}
                xName={"UnloadingBay"}
                xData={sUnloading}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.UnloadingBay === "" ? false : true}
                xErrorMessage={xErrorMsg.UnloadingBay}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
                <CmpSelectFieldV1
                  xSize="small"
                  xtabIndex={"9"}
                  xLabelText="Currency"
                  xValue={vRdxWmsHead.A_Curr}
                  xOnChange={fSelectedCurrency}
                  xName={"A_Curr"}
                  xData={sCurrency}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.A_Curr === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_Curr}
                  xDisable={xDisableBasedOnGridDataLength}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <CmpTextFieldV1
                  xLabelText="ExRate"
                  xSize="small"
                  xtabIndex={"10"}
                  xValue={vRdxWmsHead.A_ExRate}
                  xType={"number"} // text/number/password
                  xName={"A_ExRate"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                  // xOnKeyUp={(e) => {
                  //   xFocusInput("A_LocName");
                  // }}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={3.5}>
                <CmpSelectFieldV1
                  xSize="small"
                  xtabIndex={"11"}
                  xLabelText="Location"
                  xValue={vRdxWmsHead.A_Loc}
                  xOnChange={fLocation}
                  xName={"A_Loc"}
                  xData={vRdxuserLoc}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.A_Loc === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_Loc}
                  xDisable={xDisableBasedOnGridDataLength}
                />
              </Grid>
          </Grid>
        </Grid>
        {sToggleGrid ? (
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Grid
              container
              spacing={0}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className="align-items-start"
            >
              <div style={{ height: 170, width: "100%" }}>
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sGridSalesHistoryRowData}
                  columns={GridDataSalesHistoryColumns}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  // onRowClick={fonRowClickGridObj}
                  hideFooter
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Grid
              container
              spacing={0.9}
              columnSpacing={0.9}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className={
                hasValueInErrorMessage(xErrorMsg)
                  ? "align-items-center"
                  : "align-items-start"
              }
            >
              <Grid item xs={12} sm={12} md={12}>
                <Grid container spacing={0}>
                  <Grid item xs={3} sm={2} md={2}>
                    <CmpTextFieldV1
                      xLabelText="Vendor"
                      xValue={vRdxWmsHead.A_Party}
                      xType={"text"} // text/number/password
                      xName={"A_Party"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={xErrorMsg.A_Party === "" ? false : true}
                      xErrorMessage={xErrorMsg.A_Party}
                    />
                  </Grid>
                  <Grid item xs={9} sm={10} md={10}>
                    <GCToggleSearchV1
                      xLabelText="Vendor Name"
                      xName={"GC_Toggle_Head_Customer_Name"}
                      xType={"text"}
                      xValue={vRdxWmsHead.A_PartyName}
                      xReadOnly={false}
                      xOnChange={xfGC_Toggle_Head_Customer_Name} //GCToggleSearch onchange main input
                      xOnKeyUp={xGC_Toggle_Head_Customer_onKeyUp} //GCToggleSearch xOnKeyUp main input
                      xError={xErrorMsg.A_PartyName === "" ? false : true}
                      xErrorMessage={xErrorMsg.A_PartyName}
                      xMediaQuery={false}
                      xonClickbtn={xGC_Toggle_Head_Customer_onKeyUp} // GCToggleSearch onclick icon open div on main screen
                      xrows={xGC_Toggle_Head_Customer_GridData} //GCToggleSearch-grid
                      xcolumns={xGC_Toggle_Head_Customer_GridColumns} //GCToggleSearch-grid
                      xRowCellClick={xfGC_Toggle_Head_Customer_OnCellKeyDown}
                      xRowClick={xfGC_Toggle_Head_Customer_OnRowClick}
                      xToggle={xGC_Toggle_Head_Customer_Toggle} //GCToggleSearch- true/false
                      xData={xGC_Toggle_Head_Customer_DropDown_Arr} //GCToggleSearch-select
                      xOnChangeDropdownInput={
                        xGC_Toggle_Head_Customer_Dropdown_onChange
                      } //GCToggleSearch -input
                      xDropdownObj={xGC_Toggle_Head_Customer_SearchDropdownObj} //GCToggleSearch -obj
                      xOnKeyUpDropdownInput={
                        xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
                      } //GCToggleSearch -Enter key and clickc detect
                      xtabIndex="7"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={6} sm={6} md={4}>
                <CmpSelectArrFieldV1
                  xLabelText="Type"
                  xSize="small"
                  xValue={vRdxWmsHead?.A_Type}
                  xOnChange={fOutboundType}
                  xName={"A_Type"}
                  xData={sOutboundType}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.A_Type === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_Type}
                  xDisable={false}
                  xtabIndex={"8"}
                />
              </Grid>

            

              <Grid item xs={"6"} sm={6} md={4}>
                <CmpSelectFieldV1
                  xSize="small"
                  xtabIndex={"12"}
                  xLabelText="Tax"
                  xValue={vRdxWmsHead.TaxType}
                  xOnChange={fTax}
                  xName={"TaxType"}
                  xData={sTax}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.TaxType === "" ? false : true}
                  xErrorMessage={xErrorMsg.TaxType}
                  xDisable={xDisableBasedOnGridDataLength}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <CmpCheckboxField
                  xtabIndex={"13"}
                  xChecked={vRdxWmsHead?.offer === "Y"}
                  xOnChange={fOffer}
                  xDisabled={false}
                  xName={"offer"}
                  xNameField={"Offer"}
                  xError={xErrorMsg.offer === "" ? false : true}
                  xErrorMessage={xErrorMsg.offer}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <CmpCheckboxField
                  xtabIndex={"14"}
                  xChecked={vRdxWmsHead?.A_Taxable === "Y"}
                  xOnChange={fTaxable}
                  xDisabled={true}
                  xName={"A_Taxable"}
                  xNameField={"Tax"}
                  xError={xErrorMsg.A_Taxable === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_Taxable}
                />
              </Grid>
              {vRdxWmsHead.A_DocStat === "ENTER" ? (
                <>
                  {/* <Grid item xs={3} sm={3} md={2} lg={2}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"Net O/s Amt"}
                    />
                  </Grid> */}
                  <Grid item xs={6} sm={6} md={3}>
                    <CmpTextFieldV1
                      xLabelText="Net O/s Amt"
                      xSize="small"
                      xValue={xOsAmount.NetOsAmt}
                      xType={"text"} // text/number/password
                      xName={"NetAmtWithoutPDC"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={false}
                      xErrorMessage={""}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={3}>
                    <CmpTextFieldV1
                      xLabelText="PDC Amt"
                      xSize="small"
                      xValue={xOsAmount.PDCAmt}
                      xType={"text"} // text/number/password
                      xName={"PDCAmt"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={false}
                      xErrorMessage={""}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={3}>
                    <CmpTextFieldV1
                      xLabelText="Balance O/s Amt"
                      xSize="small"
                      xValue={xOsAmount.BalanceOsAmt}
                      xType={"text"} // text/number/password
                      xName={"BalanceOsAmt"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={false}
                      xErrorMessage={""}
                    />
                  </Grid>
                </>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
    </form>
  );
}
